import { IPortalConfigMap } from './i-portal-config-map';
import { PartnerPortalConfig } from './partner-portal-config';
import { PartnerMPPortalConfig } from './partnermp-portal-config';
import { SeOpsPortalConfig } from './seops-portal-config';

//Maintains a dictionary or portal X config
//TODO: Other PC variations to be added
export const PortalConfigMap = <IPortalConfigMap>{
  partner: new PartnerPortalConfig(),
  partnerMP: new PartnerMPPortalConfig(),
  seops: new SeOpsPortalConfig(),
  salesops: new SeOpsPortalConfig(),
};
